// frontend/src/features/wind/ui.js
import React from "react";

/** Top summary chip */
export function InfoChip({ label, value, detail }) {
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/70 px-4 py-3 flex flex-col gap-1">
      <div className="text-[11px] uppercase tracking-wide text-slate-400">
        {label}
      </div>
      <div className="text-base font-semibold text-slate-50">{value}</div>
      {detail && <div className="text-[11px] text-slate-500">{detail}</div>}
    </div>
  );
}

/** Horizontal divider + label */
export function SectionHeader({ label }) {
  return (
    <div className="mt-3 mb-1 flex items-center gap-2">
      <div className="h-px flex-1 bg-slate-800" />
      <div className="text-[10px] uppercase tracking-[0.16em] text-slate-400">
        {label}
      </div>
      <div className="h-px flex-1 bg-slate-800" />
    </div>
  );
}

/** Label/value row in subject view */
export function PlaceholderRow({ label, value }) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="text-[11px] text-slate-400">{label}</div>
      <div className="text-[11px] text-slate-100 text-right flex-1">
        {value}
      </div>
    </div>
  );
}

/** Card in the project list */
export function MiniProjectCard({
  name,
  location,
  capacity,
  note,
  selected,
  active,
  onToggle,
  onClick,
}) {
  return (
    <div
      className={[
        "rounded-xl border px-3 py-2.5 transition cursor-pointer",
        active
          ? "border-sky-400 bg-sky-900/20 shadow-[0_0_0_1px_rgba(56,189,248,0.5)]"
          : selected
          ? "border-emerald-400 bg-emerald-900/20"
          : "border-slate-800 bg-slate-950/70 hover:border-slate-600 hover:bg-slate-900/80",
      ].join(" ")}
      onClick={onClick}
    >
      <div className="flex items-start gap-2 mb-1">
        <input
          type="checkbox"
          className="mt-[2px] h-3 w-3 rounded border-slate-500 bg-slate-900"
          checked={selected}
          onChange={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <div className="flex-1">
          <div className="flex items-center justify-between gap-2 mb-0.5">
            <div className="text-[11px] font-semibold text-slate-100 line-clamp-2">
              {name}
            </div>
            <span className="text-[10px] text-emerald-300 whitespace-nowrap">
              {capacity}
            </span>
          </div>
          <div className="text-[10px] text-sky-300 mb-1 line-clamp-1">
            {location}
          </div>
          <div className="text-[10px] text-slate-400 line-clamp-2">{note}</div>
        </div>
      </div>
    </div>
  );
}
